import React, { useEffect, useState, useRef } from 'react';

interface ScrollCounterProps {
	endNumber: number;
	time: number;
	prefix?: string;
	postfix?: string;
	useOneDecimal?: boolean;
	useTwoDecimals?: boolean;
}

const ScrollCounter = (props: ScrollCounterProps) => {
	const [count, setCount] = useState(0);
	const elementRef = useRef(null);
	const [isVisible, setIsVisible] = useState(false);
	const easeOut = (progress: number) => 1 - Math.pow(1 - progress, 3);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.5 }
		);

		if (elementRef.current) {
			observer.observe(elementRef.current);
		}

		return () => {
			if (observer && elementRef.current) {
				observer.unobserve(elementRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (isVisible) {
			let start: any = null;

			const animate = (timestamp: number) => {
				if (!start) start = timestamp;
				const progress = Math.min((timestamp - start) / props.time, 1);
				const easedProgress = easeOut(progress);

				setCount(Math.floor(easedProgress * props.endNumber));

				if (progress < 1) {
					requestAnimationFrame(animate);
				}
			};

			requestAnimationFrame(animate);
		}
	}, [isVisible, props.endNumber, props.time]);

	const formattedCount = props.useTwoDecimals
		? (count / 1000).toFixed(2).toString().replace('.', ',')
		: props.useOneDecimal
			? (count / 1000).toFixed(1).toString().replace('.', ',')
			: count.toLocaleString();

	return (
		<div ref={elementRef}>
			<span>{props.prefix}{formattedCount}{props.postfix}</span>
			{/*<span>{props.prefix}{count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{props.postfix}</span>*/}
		</div>
	);
};

export default ScrollCounter;
